module.exports = __webpack_public_path__ + "static/img/gsjs_01.21b14f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gsjs_01.jpg
// module id = 0+UH
// module chunks = 1